import { useContext } from 'react';

import { MEDIA_URL } from '../Context';

import { DocumentForm } from './common/DocumentForm';


export default function SendContract ({order, selectedYear}){
  const media_url = useContext(MEDIA_URL);

  return (
    <>
      <div className="row">
        <h3 className="m-3">Отправить подписанный договор в АСНП ЦВКК</h3>
      </div>
      <div className="row">
        <div className="col-9">
          <>
            <p className="m-3 flex-grow-1 align-content-center">Пожалуйста распечатайте и подпишите <a href={media_url + order["contract_pdf"]} download>договор</a> и <a href={media_url + order["order_form_pdf"]} download> бланк заказа</a>. Отправьте сканы подписанных документов в АСНП ЦВКК:</p>    
            <div className='mt-5 m-3'>
              <DocumentForm
                year={selectedYear} 
                orderformFilename="user_signed_order_form_file" 
                contractFilename="user_signed_contract_file" 
              />                       
            </div> 
          </>
        </div>
      </div> 
    </>
  )
}